var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"mt-5 pa-5",attrs:{"cols":"12"}},[_c('v-card',[_c('v-card-title',{domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.articleText)}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }